import React from 'react';
import { Checkbox, Form } from 'antd';
import Text from 'components/Text/Text';
import style from './IsHiddenCheckbox.module.scss';

interface IProps {
	toggleIsHidden: () => void;
	isHidden: boolean;
	isDisabled: boolean;
}

export const IsHiddenCheckbox: React.FC<IProps> = React.memo(({ toggleIsHidden, isHidden, isDisabled }) => {
	return (
		<Form.Item className={style.container} name="isHidden" data-test="IsHiddenCheckbox">
			<Checkbox onChange={toggleIsHidden} checked={isHidden} disabled={isDisabled}>
				<Text translationNameSpace="form" translationKey="isHiddenLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
});
